"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
class GetDefaultPropositionsResponseProductDetailsRates extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 0.415, description: 'The gas rates without VAT between 1-5000 m³' }),
    tslib_1.__metadata("design:type", Number)
], GetDefaultPropositionsResponseProductDetailsRates.prototype, "gasRateRanges_1_5000", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 0.325, description: 'The gas rates without VAT between 5001-170000 m³' }),
    tslib_1.__metadata("design:type", Number)
], GetDefaultPropositionsResponseProductDetailsRates.prototype, "gasRateRanges_5001_170000", void 0);
exports.default = GetDefaultPropositionsResponseProductDetailsRates;
